export const helpCenterUrl = 'https://stage2.10n.com/help-center';

export const FAVOURITE_SYMBOLS_MAX_LIMIT = 15;
export const RECENTLY_VIEWED_SYMBOLS_MAX_LIMIT = 10;
export const SHORT_SELL_DAILY_INTEREST_FEE = 0.00016;
